import React, { useContext } from 'react';
import { useStyletron } from 'baseui';
import { Heading, HeadingLevel } from 'baseui/heading';
import { faDownload, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { nanoid } from 'nanoid';
import { Button, ButtonRow, FileIcon } from '@gtintel/platform-atoms';
import { COOKIE_NAMES } from '@gtintel/platform-constants';
import { formatDateTime, getSessionStorageItem } from '@gtintel/platform-utils';
import FileUpload from '../FileUpload';
import { FlatDocumentsContext } from './contexts';
export const Document = ({
  attachment,
  canDelete,
  isLeadPartnerAssignment = false
}) => {
  const {
    removeAttachment
  } = useContext(FlatDocumentsContext);
  const [css] = useStyletron();
  const user = getSessionStorageItem(COOKIE_NAMES.INFOR_USER);

  // If assignment.is_lead_partner_assignment = True, the NP should be able to see ALL assignment documents but NOT
  // be able to delete the document. This shows up as the attachment having a different uploaded_by id than the user
  if (isLeadPartnerAssignment && user?.id !== attachment.uploaded_by) {
    canDelete = false;
  }
  return <div className={css({
    backgroundColor: '#fff',
    borderBottom: '2px solid #e2e2e2',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '8px 12px',
    width: '100%'
  })}>
      <div className={css({
      alignItems: 'center',
      display: 'flex',
      flexFlow: 'row nowrap'
    })}>
        <FileIcon extension={attachment.extension} />
        <div className={css({
        display: 'flex',
        flexFlow: 'column nowrap',
        marginLeft: '8px'
      })}>
          <small className={css({
          marginBottom: '-4px',
          position: 'relative'
        })}>
            {attachment.size}
            {/* Upload time disambiguates rework rounds re-using a filename */}
            {attachment.created_at && ` · uploaded ${formatDateTime(attachment.created_at)}`}
          </small>
          <h5 className={css({
          margin: '0'
        })}>{attachment.filename}</h5>
        </div>
      </div>
      <ButtonRow flexPosition="flex-end">
        <a href={attachment.url} download={attachment.filename} data-testid={`${attachment.id}-download-button`} className={css({
        padding: '10px 12px'
      })}>
          <FontAwesomeIcon icon={faDownload} size="lg" title="Download attachment" />
        </a>
        {canDelete && <Button testId={`${attachment.id}-delete-button`} size="compact" kind="tertiary" onClick={async () => {
        await removeAttachment(attachment.id, 'document');
      }}>
            <FontAwesomeIcon icon={faXmark} style={{
          color: '#e11900'
        }} size="lg" title="Delete attachment" />
          </Button>}
      </ButtonRow>
    </div>;
};
const DocumentsFlatList = ({
  canUpload = false,
  canDelete = false,
  isLeadPartnerAssignment = false,
  attachments
}) => {
  const {
    addAttachment,
    documents
  } = useContext(FlatDocumentsContext);
  const [css] = useStyletron();
  const docs = attachments ?? documents();
  return <div data-testid="flat-attachments-list">
      <HeadingLevel>
        {canUpload && <FileUpload handleUpload={async file => addAttachment(file, 'document')} />}

        {docs?.length > 0 ? <div className={css({
        border: '2px solid #e2e2e2',
        borderBottomColor: 'transparent',
        borderRadius: '8px',
        display: 'flex',
        flexFlow: 'column nowrap',
        marginBottom: '48px',
        overflow: 'hidden'
      })}>
            {docs.map(attachment => {
          return <Document key={nanoid()} attachment={attachment} canDelete={canDelete} isLeadPartnerAssignment={isLeadPartnerAssignment} />;
        })}
          </div> : <div className={css({
        alignItems: 'center',
        background: 'white',
        border: '1px solid #e2e2e2',
        borderRadius: '4px',
        display: 'flex',
        flexFlow: 'column nowrap',
        justifyContent: 'center',
        padding: '48px 0'
      })}>
            <HeadingLevel>
              <Heading>No Files Uploaded</Heading>
            </HeadingLevel>
          </div>}
      </HeadingLevel>
    </div>;
};
export default DocumentsFlatList;